// const BASE_URL =
//   process.env.REACT_APP_API_URL ||
//   "http://localhost:5000/api";

import { API_BASE, UPLOADS_URL } from "../config";

const BASE_URL = API_BASE;



const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Une erreur est survenue');
  }
  return response.json();
};



const handleError = (error) => {
  console.error('Erreur:', error);
  throw error;
};


const getHeaders = () => {
  const id_user = JSON.parse(sessionStorage.getItem('id_user'));
  const token = JSON.parse(sessionStorage.getItem('token'));
  const headers = {};

  if (id_user && token) {
    headers['x-access-token'] = token;
    headers['x-access-id_user'] = id_user;
  }

  return headers;
};


export const get = async (endpoint = '') => {
  try {
    const headers = getHeaders();
    const response = await fetch(`${BASE_URL}/${endpoint}`, { headers });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};


export const getImage = async (endpoint = '') => {
  try {
    const response = await fetch(`${UPLOADS_URL}/${endpoint}`);
    return response;
  } catch (error) {
    handleError(error);
  }
};

export const post = async (
  endpoint = "",
  data = {}
) => {
  try {
    const headers = getHeaders();

    const isFormData =
      data instanceof FormData;

    const requestHeaders = {
      "x-access-token":
        headers["x-access-token"],
      "x-access-id_user":
        headers["x-access-id_user"],
    };

    // seulement JSON si ce n est PAS FormData
    if (!isFormData) {
      requestHeaders["Content-Type"] =
        "application/json";
    }

    const response = await fetch(
      `${BASE_URL}/${endpoint}`,
      {
        method: "POST",
        headers: requestHeaders,

        body: isFormData
          ? data
          : JSON.stringify(data),
      }
    );

    return handleResponse(response);

  } catch (error) {
    handleError(error);
  }
};

export const postLogin = async (data = {}) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const checkPassword = async (data = {}) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/checkpass`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const updatedpassword = async (data = {}) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/updatepassword`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};


export const patch = async (endpoint = '', data = {}) => {
  try {
    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};


export const del = async (endpoint = '') => {
  try {
    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method: 'DELETE',
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};


export const deleteRequest = async (endpoint = '') => {
  try {
    const headers = getHeaders();

    const actionHeaders = /^follows\/\d+$/.test(endpoint)
      ? { 'x-carrerup-action': 'unfollow' }
      : {};

    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': headers['x-access-token'],
        'x-access-id_user': headers['x-access-id_user'],
        ...actionHeaders
      }
    });

    return handleResponse(response);

  } catch (error) {
    handleError(error);
  }
};


export const patchRequest = async (endpoint = '', data = {}, isFormData = false) => {
  try {
    const headers = getHeaders();

    const options = {
      method: 'PATCH',
      headers: {
        'x-access-token': headers['x-access-token'],
        'x-access-id_user': headers['x-access-id_user']
      }
    };

    if (isFormData) {
      // ⚠️ NE PAS définir Content-Type
      options.body = data;
    } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(data);
    }

    const response = await fetch(`${BASE_URL}/${endpoint}`, options);
    return handleResponse(response);

  } catch (error) {
    handleError(error);
  }
};


export const changePassword = async (data = {}) => {

  try {

    const headers = getHeaders();

    const response =
      await fetch(
        `${BASE_URL}/users/change-password`,
        {
          method: "PATCH",

          headers: {
            "Content-Type": "application/json",
            "x-access-token":
              headers["x-access-token"],

            "x-access-id_user":
              headers["x-access-id_user"]
          },

          body: JSON.stringify(data)
        }
      );

    return handleResponse(response);

  }
  catch (error) {

    handleError(error);

  }

};


export const sendContactMessage =
  async (data = {}) => {

    try {

      const response =
        await fetch(

          `${BASE_URL}/contact`,

          {

            method: "POST",

            headers: {

              "Content-Type":
                "application/json"

            },

            body:
              JSON.stringify(data)

          }

        );

      return handleResponse(
        response
      );

    }
    catch (error) {

      handleError(
        error
      );

    }

  };



// reset password

export const sendResetCode = async (data = {}) => {

  try {

    const response =
      await fetch(
        `${BASE_URL}/users/send-reset-code`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify(data)
        }
      );

    return handleResponse(
      response
    );

  }
  catch (error) {

    handleError(error);

  }

};


export const verifyResetCode = async (data = {}) => {

  try {

    const response =
      await fetch(
        `${BASE_URL}/users/verify-reset-code`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify(data)
        }
      );

    return handleResponse(
      response
    );

  }
  catch (error) {

    handleError(error);

  }

};


export const resetPassword = async (data = {}) => {

  try {

    const response =
      await fetch(
        `${BASE_URL}/users/reset-password`,
        {
          method: "PATCH",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify(data)
        }
      );

    return handleResponse(
      response
    );

  }
  catch (error) {

    handleError(error);

  }

};
